import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import GetTypeWiseDocuments from '@features/supplier/component/GetTypeWiseDocuments';
import AddAuditReport from '@features/supplier/component/AddAuditReport';
import ViewDocuments from '@features/supplier/component/ViewDocuments';

import { useSupplierDocuments } from '@store/reducers/supplier-onboarding/OnboardingReducer';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { getSupplierDocuments, removeSupplierDocuments } from '@services/supplierOnboardingService';

import { capitalizeFirstLetter, printApiError } from '@utils/Util';

const AuditReports = () => {
	const documents = useSupplierDocuments();
	const [isAdd, setIsAdd] = useState(false);
	const [isShowView, setIsShowView] = useState(false);
	const [selectedDocuments, setSelectedDocuments] = useState([]);
	const dispatch = useDispatch();
	const { id } = useParams();

	function groupByAuditReportType(data) {
		return data.reduce((acc, item) => {
			const type = item.auditReportType;
			if (!acc[type]) {
				acc[type] = [];
			}
			acc[type].push(item);
			return acc;
		}, {});
	}

	const renderAuditReports = () => {
		let auditReports = documents?.auditReportList || [];

		const groupedData = groupByAuditReportType(auditReports);

		return Object.keys(groupedData)?.map((auditReportKey) => {
			let sortredData = groupedData[auditReportKey].sort((a, b) => {
				return b.documentResponse.id - a.documentResponse.id;
			});
			return (
				<React.Fragment key={auditReportKey}>
					<GetTypeWiseDocuments
						documents={{ auditReportList: [sortredData[0]] }}
						title={capitalizeFirstLetter(sortredData[0].auditReportType.replaceAll('_', ' '))}
						fieldName="auditReportList"
						onViewClick={() => {
							setSelectedDocuments(sortredData);
							setIsShowView(true);
						}}
						isShowRemove={false}
					/>
				</React.Fragment>
			);
		});
	};

	const onRemoveDocument = async (docId) => {
		try {
			dispatch(openLoader());
			await removeSupplierDocuments(id, docId);
			setSelectedDocuments(selectedDocuments.filter((item) => item.documentResponse.id !== docId));
			await dispatch(getSupplierDocuments(id));
			dispatch(closeLoader());
		} catch (e) {
			dispatch(closeLoader());
			printApiError(e);
		}
	};

	return (
		<>
			<div className="section-padding hover-section">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">
					Audit Reports
					<span className="ml-12">
						<button
							className="blue border-0 medium-14 bg-transparent"
							onClick={() => setIsAdd(true)}
						>
							Add
						</button>
					</span>
				</h3>
				<div className="info-items_bottom">{renderAuditReports()}</div>
			</div>
			{isAdd && <AddAuditReport documents={documents} onClose={() => setIsAdd(false)} />}
			{isShowView && (
				<ViewDocuments
					onClose={() => {
						setSelectedDocuments([]);
						setIsShowView(false);
					}}
					title="Audit Reports"
					onRemoveClick={onRemoveDocument}
					documentList={selectedDocuments}
				/>
			)}
		</>
	);
};

export default AuditReports;
